import { addSeconds as dateFnsAddSeconds } from 'date-fns';
import parseDate from './parseDate';

const addSeconds = (dateTime, seconds) => {
  const parsedDateTime = parseDate(dateTime);

  return parsedDateTime ? dateFnsAddSeconds(parsedDateTime, seconds) : null;
};

export default addSeconds;
